import Vue from 'vue'
import FrontendLibrary from '@starlight-bd/frontend-library/dist/components/s-design/s-design.umd'

import '../assets/styles/style.scss'

Vue.use(FrontendLibrary)
